import { differenceInDays } from 'date-fns';

export const WISHLIST_LAST_VISIT = 'wishlist-last-visit';
export const WISHLIST_LAST_ACTIVITY = 'wishlist-last-activity';
export const WISHLIST_EMPTY_REMINDER_SHOWN = 'wishlist-empty-reminder-shown';
export const WISHLIST_ACTIVE_REMINDER_SHOWN = 'wishlist-active-reminder-shown';
export const EMPTY_REMINDER_INTERVAL_DAYS = 30;
export const ACTIVE_REMINDER_INTERVAL_DAYS = 14;
export const REMINDER_DISPLAY_DELAY_MS = 2000;
export const PREVIEW_ITEM_LIMIT = 5;

function storageKey(prefix: string, roleAssignmentId: string): string {
  return `${prefix}-${roleAssignmentId}`;
}

export function getStoredDate(prefix: string, roleAssignmentId: string): string | null {
  return localStorage.getItem(storageKey(prefix, roleAssignmentId));
}

export function setStoredDate(prefix: string, roleAssignmentId: string): void {
  localStorage.setItem(storageKey(prefix, roleAssignmentId), new Date().toISOString());
}

export function storeWishlistVisit(roleAssignmentId: string): void {
  setStoredDate(WISHLIST_LAST_VISIT, roleAssignmentId);
}

export function storeWishlistActivity(roleAssignmentId: string): void {
  setStoredDate(WISHLIST_LAST_ACTIVITY, roleAssignmentId);
}

export function daysSince(date: string): number {
  return differenceInDays(new Date(), new Date(date));
}

export function isWishlistInactive(
  lastVisit: string | null,
  lastActivity: string | null,
  intervalDays: number,
): boolean {
  return (!lastVisit || daysSince(lastVisit) >= intervalDays)
    && (!lastActivity || daysSince(lastActivity) >= intervalDays);
}

export function recordActiveReminderShown(roleAssignmentId: string): void {
  setStoredDate(WISHLIST_ACTIVE_REMINDER_SHOWN, roleAssignmentId);
}

export function recordEmptyReminderShown(roleAssignmentId: string): void {
  setStoredDate(WISHLIST_EMPTY_REMINDER_SHOWN, roleAssignmentId);
}
